var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10085C0.776058 4.7154 1.81775 3.55392 3.03652 2.54869C4.40113 1.42367 5.93762 0.621565 7.67724 0.256974C10.7502 -0.388873 13.5888 0.184056 16.1774 1.96013C17.6618 2.98099 18.865 4.26747 19.8337 5.78834C20.0421 6.11126 20.0421 6.40294 19.8337 6.72586C18.2295 9.19466 16.1358 11.0853 13.2919 11.9812C9.71895 13.1062 6.41159 12.4708 3.40632 10.252C2.10421 9.28841 1.03648 8.1061 0.177087 6.73628C0.109377 6.63211 0.0572929 6.52273 0 6.41335C0 6.30918 0 6.20502 0 6.10085ZM18.6566 6.23106C18.2764 5.7623 17.9275 5.28312 17.5264 4.84561C15.6462 2.79349 13.3961 1.46533 10.5575 1.28304C9.3179 1.20491 8.11475 1.36637 6.95327 1.77784C4.6251 2.60077 2.84902 4.13726 1.44274 6.13731C1.36461 6.25189 1.40107 6.3196 1.46357 6.40814C2.32297 7.63734 3.34903 8.69986 4.59385 9.53842C7.07827 11.2103 9.76583 11.6947 12.6617 10.8666C14.1774 10.4343 15.4847 9.62175 16.6462 8.56965C17.4014 7.88213 18.0629 7.11649 18.6566 6.23106Z",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7502 6.2631C13.7502 8.34127 12.0678 10.008 9.98445 10.008C7.92191 10.008 6.25 8.32564 6.25 6.25268C6.25 4.17451 7.92712 2.50781 10.0157 2.50781C12.0782 2.51302 13.7502 4.19014 13.7502 6.2631ZM7.50003 6.25789C7.50003 7.6225 8.63026 8.75794 9.99487 8.75794C11.3595 8.76315 12.4949 7.63292 12.5001 6.26831C12.5053 4.89849 11.3699 3.75263 9.99487 3.75784C8.63026 3.76305 7.50003 4.89328 7.50003 6.25789Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.1c4dde38b3dbee039cfbb72ccd40e2ac.svg";
export { ForwardRef as ReactComponent };